import { Box, Button, Dialog, DialogContent } from "@mui/material";
import React, { useEffect, useState } from "react";
import Splitter from "../../sign-in-splitter/Splitter";
import CloseIcon from "@mui/icons-material/Close";
import AgentSignUp from "../../agent/agent-sign-up/AgentSignUp";
import {
  loginItemsSelector,
  setAgentSignupStepCount,
} from "../../../redux/login";
import { useDispatch, useSelector } from "react-redux";
import AgentEmailVerification from "../../agent/agent-sign-up/AgentEmailVerification";
import ApplicationSubmitted from "../../agent/agent-sign-up/ApplicationSubmit";
import UploadDocuments from "../../agent/agent-sign-up/UploadDocuments";
import ReferredBy from "../../agent/agent-sign-up/referredBy";
import { useTranslation } from "react-i18next";

const AgentRegistrationDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isAgentLogin, setIsAgentLogin] = useState(false);
  const { agentSignUpData } = useSelector(loginItemsSelector);
  const currentStep = agentSignUpData?.agentSignUpStep || 1;
  const editableSteps = [
    { id: 1, labelKey: "AgentRegistration.Steps_Details" },
    { id: 2, labelKey: "AgentRegistration.Steps_Documents" },
    { id: 3, labelKey: "AgentRegistration.Steps_Referral" },
    { id: 4, labelKey: "AgentRegistration.Steps_Verify" },
  ];

  const handleStepSelect = (stepId) => {
    if (stepId < currentStep && stepId <= 4) {
      dispatch(setAgentSignupStepCount(stepId));
    }
  };
  const handleDialogClose = () => {
    if (currentStep === 5) {
      localStorage.removeItem("agent_signup_data");
      localStorage.removeItem("agentEmail");
      dispatch(setAgentSignupStepCount(1));
    }
    onClose();
  };
  useEffect(() => {
    // dispatch(setAgentSignupStepCount(1));
    // localStorage.removeItem("agent_signup_data");
  }, []);
  return (
    <>
      <Dialog
        open={open}
        onClose={handleDialogClose}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: "780px",
            height: "640px",
            borderRadius: "10px",
            overflow: "hidden",
            boxShadow:
              "0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04)",
          },
        }}
        aria-labelledby="agent-registration-dialog"
      >
        <DialogContent sx={{ p: 0, height: "100%", overflow: "hidden" }}>
          <Box className="auth-dialog">
            {/* LEFT – SPLITTER */}
            <Box className="auth-left">
              <Splitter variant="agentSignup" />
            </Box>

            {/* RIGHT – FORM */}
            <Box className="auth-right">
              <Button
                onClick={handleDialogClose}
                sx={{
                  position: "absolute",
                  top: 1,
                  right: 1,
                  minWidth: "auto",
                  p: 1,
                  color: "#64748B",
                  "&:hover": { color: "#0F172A", background: "#F1F5F9" },
                  zIndex: 10,
                }}
              >
                <CloseIcon />
              </Button>
              {currentStep <= 4 && (
                <Box sx={{ px: 4, pt: 4, pb: 1 }}>
                  <Box
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: 700,
                      color: "#0F172A",
                      mb: 2,
                    }}
                  >
                    {t("AgentRegistration.Step")} {currentStep} {t("AgentRegistration.Of")} {editableSteps.length}
                  </Box>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                      gap: 1,
                    }}
                  >
                    {editableSteps.map((step) => {
                      const isActive = step.id === currentStep;
                      const isCompleted = step.id < currentStep;

                      return (
                        <Box
                          key={step.id}
                          onClick={() => handleStepSelect(step.id)}
                          sx={{
                            borderRadius: "12px",
                            border: isActive
                              ? "1px solid #0085FD"
                              : "1px solid #E2E8F0",
                            background: isActive
                              ? "rgba(0, 133, 253, 0.08)"
                              : "#FFFFFF",
                            px: 1.25,
                            py: 1,
                            cursor: isCompleted ? "pointer" : "default",
                            opacity: step.id > currentStep ? 0.7 : 1,
                            transition: "all 0.2s ease",
                          }}
                        >
                          <Box
                            sx={{
                              fontSize: "0.75rem",
                              fontWeight: 700,
                              color:
                                isActive || isCompleted
                                  ? "#0085FD"
                                  : "#94A3B8",
                              mb: 0.25,
                            }}
                          >
                            {isCompleted ? t("AgentRegistration.Completed") : `${t("AgentRegistration.Step")} ${step.id}`}
                          </Box>
                          <Box
                            sx={{
                              fontSize: "0.8125rem",
                              fontWeight: 600,
                              color: "#0F172A",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {t(step.labelKey)}
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              )}
              {/* <SelectPropertyType/> */}
              {agentSignUpData?.agentSignUpStep == 1 && (
                <AgentSignUp onClose={onClose} />
              )}

              {agentSignUpData?.agentSignUpStep == 2 && (
                <UploadDocuments onClose={onClose} />
              )}
              {agentSignUpData?.agentSignUpStep == 3 && (
                <ReferredBy onClose={onClose} />
              )}
              {agentSignUpData?.agentSignUpStep == 4 && (
                <AgentEmailVerification onClose={onClose} />
              )}
              {agentSignUpData?.agentSignUpStep == 5 && (
                <ApplicationSubmitted onClose={onClose} />
              )}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AgentRegistrationDialog;
